import { render, staticRenderFns } from "./CompletedStep.vue?vue&type=template&id=5f5cd870&scoped=true"
import script from "./CompletedStep.vue?vue&type=script&setup=true&lang=js"
export * from "./CompletedStep.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5cd870",
  null
  
)

export default component.exports